import { useMemo } from 'react';
import { useIsFirstUse } from '../useIsFirstUse';
import { useDoesMetricExist } from './useDoesMetricExist';
import { useIncrementMetric } from './useIncrementMetric';
/**
 * @deprecated This is a minimally implemented user profile service, intended to unblock FirstRun and Teaching UI
 * in the React application. Do not use for other existing or new scenarios. This also lacks support for desktop or other scenarios requiring web-based storage (ie local or session storage)
 *
 * @returns UserProfileService
 */
export var useLegacyUserProfileService = function () {
    var incrementMetric = useIncrementMetric();
    var doesMetricExist = useDoesMetricExist();
    var isFirstUse = useIsFirstUse();
    return useMemo(function () {
        return {
            doesMetricExist: doesMetricExist,
            incrementMetric: incrementMetric,
            isFirstVisit: function () { return isFirstUse; },
        };
    }, [doesMetricExist, incrementMetric, isFirstUse]);
};
//# sourceMappingURL=useLegacyUserProfileService.js.map